import React from 'react'

const Home = () => {
    return (
   <>
            {/* <!-- === -->
            <!-- ============================ -->
            <!-- BANNER -->
            <!-- ============================ --> */}
            <section className="banner home_banner  header_height">
                <div className="container dark_bg">
                    <div className="left">
                        <h1 className="mainheadline text_white semibold">Meet, Greet,<br/>
                            <span className="text_violet">Match!</span>
                        </h1>
                        <p>No fuss, no muss. Find your<br/>lovebird with Peck dating.</p>
                    </div>
                    <figure className="right">
                        <img src="images/peck_logo.svg" alt=""/>
                    </figure>
                    <figure className="bg_img feather1 icon" >
                        <img src="images/feather1.png" alt=""/>
                    </figure>
                    <figure className="bg_img feather2 icon" >
                        <img src="images/featherimg2.png" alt=""/>
                    </figure>
                    <figure className="bg_img feather3 icon">
                        <img src="images/feather3.png" alt=""/>
                    </figure>
                </div>
                <figure className="bg_img center">
                    <img src="images/banner_img.png" alt=""/>
                </figure>
                <figure className="bg_img cover">
                    <img src="images/banner_bg.jpeg" alt=""/>
                </figure>
                <figure className="bg_img icon feather4">
                    <img src="images/feather4.png" alt=""/>
                </figure>
            </section>
            {/* <!-- === -->

                <!-- ============================ -->
                <!-- ABOUT -->
                <!-- ============================ --> */}
            <section className="about_peck bg_light ">
                <div className="container wide space1">
                    <div className="left">
                        <figure className="birds center">
                            <img src="images/bird_group_dark.png" alt=""/>
                        </figure>
                        <h2 className="headline mb ">What the <span className="text_violet bold">Peck</span> is it?</h2>
                        <p>Ready to dive into the dating game? Give Peck a try the new and coolest dating app on the block! The app
                            that
                            is always your Wingman, gets you dates and lets you slide into DMs. Peck is all about freedom. All are equal here. Its
                            all
                            about connections, not shying away and taking control.</p>
                        <ul className="social_listing mt">
                            <li>
                                <a href="https://apps.apple.com/us/app/peck-pride-meet-greet-match/id6469529163" className="bttn lg">
                                    <figure><img src="images/app_store_white.svg" alt=""/></figure>
                                </a>
                            </li>
                            <li>
                                <a href="https://play.google.com/store/apps/details?id=com.fliptree.peck" className="bttn lg">
                                    <figure><img src="images/playstore_white.svg" alt=""/></figure>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <figure className="right shaped_bg">
                        <img src="images/img_2.png" alt=""/>
                    </figure>
                </div>
                <figure className="bg_img top">
                    <img src="images/bg_1.png" alt=""/>
                </figure>
            </section>
            {/* <!-- === -->

                <!-- ============================ -->
                <!-- BG BLOCK -->
                <!-- ============================ --> */}
            <section className="bg_block space2">
                <div className="container dark_bg">
                    <figure className="left icon">
                        <img src="images/img_3.png" alt=""/>
                    </figure>
                    <div className="right text_violet">
                        <h2 className="headline text_violet mb semibold">We're all about diversity and making everyone feel welcome at our
                            Nest!</h2>
                        <p>Birds of all feathers are welcome at peck. Peck is all about bringing people together, no matter who you are
                            or who you love. Let's make connections that warm your heart and celebrate the beauty of diversity. Join us
                            for love, laughter, and endless possibilities!</p>
                    </div>
                </div>
                <figure className="bg_img cover">
                    <img src="images/bg_1.jpeg" alt=""/>
                </figure>
            </section>
            {/* <!-- === -->

                <!-- ============================ -->
                <!-- WINGMAN -->
                <!-- ============================ --> */}
            <section className="wingman space3" id="features">
                <div className="container text-center">
                    <div className="short">
                        <span className="subtext semibold mb-2 d-block gray_light">Let Peck be your</span>
                        <h2 className="text_violet headline bold mb">Wingman!</h2>
                        <p>Get more matches with custom prompts and unique cues. Got a crush, we will set you up!</p>
                    </div>
                    <ul className="wingman_list">
                        <li>
                            <div className="flex_body">
                                <figure className="icon"><img src="images/wing_1.png" alt=""/></figure>
                                <span className="overlay subtext">
                                    Offer a
                                    <span className="fw-semibold subheadline bold">RIDE</span>
                                </span>
                            </div>
                        </li>
                        <li>
                            <div className="flex_body">
                                <figure className="icon"><img src="images/wing_2.png" alt=""/></figure>
                                <span className="overlay subtext">
                                    Offer a
                                    <span className="fw-semibold subheadline bold">DRINK</span>
                                </span>
                            </div>
                        </li>
                        <li>
                            <div className="flex_body">
                                <figure className="icon"><img src="images/wing_3.png" alt=""/></figure>
                                <span className="overlay subtext">
                                    Offer a
                                    <span className="fw-semibold subheadline bold">COFFEE</span>
                                </span>
                            </div>
                        </li>
                        <li>
                            <div className="flex_body">
                                <figure className="icon"><img src="images/wing_4.png" alt=""/></figure>
                                <span className="overlay subtext">
                                    Offer a
                                    <span className="fw-semibold subheadline bold">ROSE</span>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                <figure className="cover bg_img">
                    <img src="images/bg_6.jpeg" alt=""/>
                </figure>
            </section>
            {/* <!-- === -->

                <!-- ============================ -->
                <!-- MATCHMAKING -->
                <!-- ============================ --> */}
            <section className="matchmaking space4 bg_light">
                <div className="container text-center">
                    <span className="subtext text_violet mb-2">Tailored</span>
                    <h2 className="headline text_violet mb-3 bold">Matchmaking</h2>
                    <p>Say goodbye to endless swiping and hello to meaningful connections.</p>
                </div>
                <div className="img_wrap">
                    <figure className="parent_img">
                        <img src="images/matchmaking_bg.png" alt="" className="desktop_visible_mob"/>
                            <img src="images/mob_bg2.png" alt="" className="mob_visible"/>
                            </figure>
                            <figure className="bg_img icon">
                                <img src="images/phone_wrap.png" alt=""/>
                            </figure>
                        </div>
                    </section>
                    {/* <!-- === -->
                        <!-- ============================ -->
                        <!-- FALL IN LOVE -->
                        <!-- ============================ --> */}
                    <section className="anonymously bg_light">
                        <div className="container">
                            <div className="left">
                                <h3 className="subheadline text_violet semibold">Fall in Love</h3>
                                <h2 className="headline bold">Anonymously</h2>
                            </div>
                            <div className="right">
                                <p>Chat as strangers. Find out who your secret admirers are through </p>
                                <span className="subheadline semibold">Hoot Mode.</span>
                            </div>
                        </div>
                        <figure className="bg_img cover">
                            <img src="images/owl_bg.png" alt=""/>
                        </figure>
                    </section>
                    {/* <!-- === -->
                        <!-- ============================ -->
                        <!-- LIND LOVE STORY -->
                        <!-- ============================ --> */}
                    <section className="about_story space5 bg_light">
                        <div className="container dark_bg">
                            <figure className="left icon"><img src="images/mob_img.png" alt=""/></figure>
                            <div className="right">
                                <figure className="birds center">
                                    <img src="images/bird_group_light.png" alt=""/>
                                </figure>
                                <h2 className="subheadline">A Blind <span className="headline bold">Love Story</span></h2>
                                <p>Sarah and Karthi, both initially doubtful about going on blind dates, found each other on Peck while
                                    maintaining their anonymity. Their first face-to-face encounter took place in a cozy cafe. The initial
                                    nervousness on their faces transformed into genuine laughter, igniting an immediate connection between them.
                                    It was as if Cupid's arrow had found its mark while they shared their stories and enjoyed their lattes.
                                    Another day, another successful match, just one Peck away.</p>
                                <p>Feel free to download and write your own story today!</p>
                                <ul className="social_listing mt2">
                                    <li>
                                        <a href="https://apps.apple.com/us/app/peck-pride-meet-greet-match/id6469529163" className="bttn bg_white lg">
                                            <figure><img src="images/app_store_violet.svg" alt=""/></figure>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://play.google.com/store/apps/details?id=com.fliptree.peck" className="bttn bg_white lg">
                                            <figure><img src="images/play_store_violet.svg" alt=""/></figure>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <figure className="bg_img cover">
                            <img src="images/about_bg2.png" alt=""/>
                        </figure>
                    </section>
                    {/* <!-- === --> */}
                    <div className="scan_refer_wrap">
                        {/* <!-- ============================ -->
                            <!-- SCAN -->
                            <!-- ============================ --> */}
                        <section className="scan  bg_light space6">
                            <div className="container">
                                <div className="left">
                                    <figure className="birds">
                                        <img src="images/bird_group_dark.png" alt=""/>
                                    </figure>
                                    <h2 className="subheadline text_gray mb">Join <span className="headline text_violet bold">Peck</span></h2>
                                    <p>Today is a great day to explore the new skies and meet new fiends!</p>
                                    <div className="btn_holder">
                                        <a href="https://qrcodes.pro/YwhMm2" className="bttn mt2">
                                            Download Now
                                        </a>
                                    </div>
                                </div>
                                <div className="right scan_block">
                                    <figure><img src="images/scan2.png" alt=""/></figure>
                                    <div className="popup bttn">
                                        SCAN ME
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- === -->
                            <!-- ============================ -->
                            <!-- REFER -->
                            <!-- ============================ --> */}
                        <section className="refer bg_light">
                            <div className="container space7">
                                <div className="cnt">
                                    <p className=" subheadline text_violet">
                                        Get access to Peck’s premium features by collecting points through referrals.
                                    </p>
                                </div>
                            </div>
                            <figure className="bg_img cover icon">
                                <img src="images/sound_img.png" alt=""/>
                            </figure>
                        </section>
                        {/* <!-- === --> */}
                        <div className="bg_img feather1 icon">
                            <img src="images/feather8.png" alt=""/>
                        </div>
                    </div>
                </>
                )
}

                export default Home